import PropTypes from 'prop-types';
import React, { useState } from 'react';

const PaymentAccordion = ({ tableData, toggledRows, setToggledRows }) => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const handleAccordionToggle = idx => {
    setOpenAccordion(openAccordion === idx ? null : idx);
  };
  const handleToggleClick = (rowKey) => {
    setToggledRows((prev) =>
      prev.includes(rowKey)
        ? prev.filter((k) => k !== rowKey)
        : [...prev, rowKey]
    );
  };

  return (
    <div className="md:hidden px-2 py-4">
      {tableData.length === 0 ? (
        <div className="text-center text-gray-500">No hay pagos disponibles.</div>
      ) : (
        tableData.map((p, idx) => {
          const key = p.id ? `row-${p.id}` : `row-${idx}`;
          let statusIndicator;
          let statusText;
          if (p.status === 2 || p.status === 3) {
            statusIndicator = <span className="p-2 bg-danger rounded-circle d-inline-block ms-3"></span>;
            statusText = 'Pendiente';
          } else if (p.status === 0) {
            statusIndicator = <span className="p-2 bg-warning rounded-circle d-inline-block ms-3"></span>;
            statusText = 'En Proceso';
          } else {
            statusIndicator = <span className="p-2 bg-success rounded-circle d-inline-block ms-3"></span>;
            statusText = 'Pagado';
          }

          return (
            <div key={key} className="mb-4 border rounded-lg bg-white shadow">
              <button
                className="w-full flex flex-row items-center px-4 py-3 focus:outline-none gap-2"
                onClick={() => handleAccordionToggle(idx)}
              >
                <div className="flex flex-1 font-semibold text-primary-500 text-left items-center justify-between">
                  <span>{p.category}</span>
                  <span>{statusIndicator}</span>
                </div>
                <div className="flex items-center justify-center" style={{ width: '32px', height: '32px' }}>
                  <svg
                    className="w-4 h-4 transition-transform duration-200"
                    style={{ transform: openAccordion === idx ? 'rotate(180deg)' : 'rotate(0deg)' }}
                    fill="none"
                    stroke="#253858"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </button>
              {openAccordion === idx && (
                <div className="px-4 pb-4 pt-2 text-sm text-gray-700 border-t">
                  <div className="mb-2 flex justify-between items-center">
                    <span className="font-medium">Estatus:</span>
                    <span className="flex items-center gap-2">
                      {statusText}
                      {statusIndicator}
                    </span>
                  </div>
                  <div className="mb-2 flex justify-between">
                    <span className="font-medium">Categoría:</span>
                    <span>{p.category}</span>
                  </div>
                  <div className="mb-2 flex justify-between">
                    <span className="font-medium">Fecha:</span>
                    <span>{p.createdDate}</span>
                  </div>
                  <div className="mb-2 flex justify-between items-center">
                    <span className="font-medium">Monto:</span>
                    <span className="flex items-center">
                      {p.balance}
                      {p.status === 2 && (
                        toggledRows.includes(key) ? (
                          <button
                            type="button"
                            onClick={() => handleToggleClick(key)}
                            className="inline-flex items-center justify-center rounded-full w-6 h-6 ml-2 bg-red-500 cursor-pointer hover:bg-red-600 transition-colors focus:outline-none"
                            aria-label="Quitar"
                          >
                            <svg width="12" height="12" viewBox="0 0 20 20" fill="none">
                              <path d="M4 10h12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() => handleToggleClick(key)}
                            className="inline-flex items-center justify-center rounded-full w-6 h-6 ml-2 bg-blue-500 cursor-pointer hover:bg-blue-600 transition-colors focus:outline-none"
                            aria-label="Agregar"
                          >
                            <svg width="12" height="12" viewBox="0 0 20 20" fill="none">
                              <path d="M10 4v12M4 10h12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                          </button>
                        )
                      )}
                    </span>
                  </div>
                  <div className="mb-2 flex justify-between">
                    <span className="font-medium">Referencia:</span>
                    <span>{p.referenceNumber}</span>
                  </div>
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

PaymentAccordion.propTypes = {
  tableData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    status: PropTypes.number,
    category: PropTypes.string,
    createdDate: PropTypes.string,
    balance: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })).isRequired,
  toggledRows: PropTypes.array.isRequired,
  setToggledRows: PropTypes.func.isRequired
};

export default PaymentAccordion;
